import { Boxed } from 'ngrx-forms';
import { BusinessPersonDto } from '../../../business-person/src/lib/_models/business-person-dto.model';
import { FlightBusinessPersonType } from './business-person.model';

export interface FlightBusinessPerson {
  readonly flightBusinessPersonId: number; // PK
  readonly flightBusinessPersonTypeId: number;
  readonly flightBusinessPersonTypeName: string;
  readonly businessPerson: Boxed<BusinessPersonDto> | BusinessPersonDto | null;
}

export const EMPTY_FLIGHT_BUSINESS_PERSON: FlightBusinessPerson = {
  flightBusinessPersonId: 0,
  flightBusinessPersonTypeId: FlightBusinessPersonType.UNKNOWN_FLIGHT_BUSINESS_PERSON_TYPE,
  flightBusinessPersonTypeName: 'Unknown Flight Business Person Type',
  businessPerson: null
};

export const EMPTY_FLIGHT_BUSINESS_PERSON_COLLECTION: FlightBusinessPerson[] = [
  {
    ...EMPTY_FLIGHT_BUSINESS_PERSON,
    flightBusinessPersonTypeId: FlightBusinessPersonType.REQUESTER,
    flightBusinessPersonTypeName: 'Requester'
  },
  {
    ...EMPTY_FLIGHT_BUSINESS_PERSON,
    flightBusinessPersonTypeId: FlightBusinessPersonType.PLANNER,
    flightBusinessPersonTypeName: 'Planner'
  },
  {
    ...EMPTY_FLIGHT_BUSINESS_PERSON,
    flightBusinessPersonTypeId: FlightBusinessPersonType.APPROVER,
    flightBusinessPersonTypeName: 'Approver'
  }
];
